import { AxiosInstance } from 'axios';

import { Accountable } from '../models/movimento.model';
import { BaseService } from './base.service';

export class MovementService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	searchAccountable(term: string): Promise<Accountable[]> {
		return this.mapResponse(this.http.post('/ws/movement/searchaccountable', { term }), Accountable);
	}

}